import React, { useState } from 'react';

import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { faPlus } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Honeybadger from '@honeybadger-io/js';

import { Button } from '@/components/ui/button';
import { deserializer } from '../../../../../../../shared/utils';
import { ERROR_TITLES, SUCCESS_MESSAGES } from '../../../../constants';
import { useBoard, useDialogs } from '../../../../hooks';
import { updateTaskStatus as apiUpdateTaskStatus } from '../../../../services/taskStatusService';
import { taskStatusShape } from '../../../../types';
import DropdownMenu from './DropdownMenu';

const HEADER_STYLES = 'flex items-center justify-between px-2 py-1 bg-surface rounded-md';

const NewTaskButton = ({ onClick }) => (
  <Button className="h-6 w-6 hover:bg-hover" onClick={onClick} variant="ghost">
    <FontAwesomeIcon className="text-muted-foreground" icon={faPlus} />
  </Button>
);

NewTaskButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const Header = ({ status, taskCount }) => {
  const [isMoving, setIsMoving] = useState(false);

  const { statuses, updateStatus } = useBoard();

  const { handleDeleteStatusClick, handleEditStatusClick, handleNewTaskClick } =
    useDialogs();

  const statusIdx = statuses.findIndex((s) => s.id === status.id);
  const isFirstStatus = statusIdx === 0;
  const isLastStatus = statusIdx === statuses.length - 1;

  const handleMoveClick = async (direction) => {
    setIsMoving(true);

    try {
      const serializedTaskStatus = await apiUpdateTaskStatus({
        taskStatusData: { sort_position: direction },
        taskStatusId: status.id,
      });

      const taskStatus = await deserializer.deserialize(serializedTaskStatus);
      updateStatus(taskStatus);
      toast.success(SUCCESS_MESSAGES.status.update);
    } catch (error) {
      toast.error(ERROR_TITLES.status.update, { description: error.message });
      Honeybadger.notify(error);
    } finally {
      setIsMoving(false);
    }
  };

  return (
    <div className={HEADER_STYLES}>
      <div className="flex items-center space-x-2">
        <span className="font-medium text-foreground">{capitalize(status.name)}:</span>
        <div className="font-medium text-muted-foreground">{taskCount}</div>
      </div>

      <div>
        <NewTaskButton onClick={handleNewTaskClick} />

        <DropdownMenu
          disableMoveLeft={isFirstStatus || isMoving}
          disableMoveRight={isLastStatus || isMoving}
          onDeleteStatusClick={() => handleDeleteStatusClick(status)}
          onEditStatusClick={() => handleEditStatusClick(status)}
          onMoveLeftClick={() => handleMoveClick('up')}
          onMoveRightClick={() => handleMoveClick('down')}
          onNewTaskClick={handleNewTaskClick}
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  status: taskStatusShape.isRequired,
  taskCount: PropTypes.number.isRequired,
};

export default Header;
